import { theme } from "@chakra-ui/core";

export default {
  ...theme,
  breakpoints: ["30em", "48em", "64em", "80em"],
};
